import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import ConfigurationUpload from '../../../_lib/components/ConfigurationFileUpload/ConfigurationUpload';

type UserImportConfigurationEditProps = { form: IForm };

function UserImportConfigurationEdit({ form }: UserImportConfigurationEditProps) {
  return <ConfigurationUpload namespace="UserImportConfiguration" name="file" form={form} />;
}

export const UserImportConfigurationEditView = asView(UserImportConfigurationEdit);
export type UserImportConfigurationEditView = ComponentProps<typeof UserImportConfigurationEditView>;
